// extracted by mini-css-extract-plugin
export default {"content":"Identity_content__mzves"};